<div class="ai-typing-wrapper">
    <div class="exchange-avatar">
        <app-svg-loader height="32px" url="assets/logos/tail-one-logo-chip-gradient-black.svg"></app-svg-loader>
      </div>
      <div class="bubbles" #bubblesContainer>
        <div class="bubble"></div>
        <div class="bubble"></div>
        <div class="bubble"></div>
      </div>
</div>
